import React, { useMemo } from 'react';
import {
  ALL_CATEGORY_VALUE,
  ALL_FILTER,
  CategoryCountsMap,
  CategoryListOption,
} from '@/utils/category';
import { CatalogCategoryType } from '@/contexts/item-context-types';
import { FilterType } from '@/components/filter-button';
import { HorizontalSelector } from '@/components/horizontal-selector';
import { ListOption } from '@/components/list-item';
import { PixelRatio, Platform, StyleSheet } from 'react-native';

interface Props {
  categories: CatalogCategoryType[];
  categoryCountsMap: CategoryCountsMap;
  onSelectCategory: (category?: CatalogCategoryType) => void;
  selectedCategory?: CatalogCategoryType;
}

export const LIST_HEIGHT = 40 * PixelRatio.getFontScale();

export const CategoryTabs: React.FC<Props> = ({
  categories,
  categoryCountsMap,
  onSelectCategory,
  selectedCategory,
}) => {
  const onItemPress = (item: ListOption | null) => {
    if (item) {
      const category = categories.find((c) => c.uuid === item.value);
      onSelectCategory(category);
    }
  };

  const listOptions: CategoryListOption[] = useMemo(() => {
    return categories.map((c) => {
      return {
        metadata: {
          count: c.uuid ? categoryCountsMap.get(c.uuid) : 0,
        },
        title: String(c.name),
        value: String(c.uuid),
      };
    });
  }, [categories, categoryCountsMap]);

  const selectedItem: CategoryListOption = selectedCategory
    ? {
        title: String(selectedCategory.name),
        value: String(selectedCategory.uuid),
      }
    : ALL_FILTER;

  return (
    <HorizontalSelector<CategoryListOption>
      allFilter={{
        metadata: {
          count: categoryCountsMap.get(ALL_CATEGORY_VALUE),
        },
        ...ALL_FILTER,
      }}
      containerStyle={
        Platform.OS === 'web' ? styles.listContainerLarge : styles.listContainer
      }
      contentContainerStyle={styles.listContentContainer}
      data={listOptions}
      deselectAllFilter={false}
      filterType={FilterType.TAB}
      keyExtractor={(item) => String(item.value)}
      onItemPress={onItemPress}
      scrollToItem
      selectedItem={selectedItem}
      trackingKey="catalog-category-tabs"
    />
  );
};

const styles = StyleSheet.create({
  listContainer: {
    flex: 0,
    height: LIST_HEIGHT,
  },
  listContainerLarge: {
    flex: 1,
  },
  listContentContainer: {
    marginLeft: 0,
  },
});
